// index.js

import Receipts from './Receipts';

export default Receipts;



// WEBPACK FOOTER //
// ./src/comps/Receipts/index.js